<fin-apis-passenger-checkin
  [passenger$]="passenger$"
  [hideEditButton]="hideEditButtonForPax$ | async"
  [verifiersEnabled]="verifiersEnabled$ | async"
  (openForm)="showApisForm($event?.triggerElement)"
></fin-apis-passenger-checkin>

<fin-subview [open]="subviewOpen$ | async" [subviewName]="'apis-subview'" [subviewContext]="'check-in'">
  <ng-container ngProjectAs="header">
    <fin-sub-header
      [hasBasket]="false"
      [isBasketDisabled]="true"
      [hasActiveBasketState]="false"
      [hasBasketActionInMobileOnly]="false"
      [backgroundColorClass]="'nordic-blue-900-bg'"
    >
      <div class="flex flex--middle">
        <div class="flex-1 flex--basis0">
          <fcom-button
            *ngIf="step$ | async as step"
            data-testid="check-in-subview-back"
            class="block back-button"
            [attr.title]="
              (isMobile$ | async) === true
                ? ('actions.back' | finLocalization)
                : ('MMB.checkIn.funnel.actions.navigateBack' | finLocalization)
            "
            [icon]="{
              name: SvgLibraryIcon.ARROW_LEFT,
              position: IconPosition.LEFT,
            }"
            [text]="
              (isMobile$ | async) === true
                ? ('actions.back' | finLocalization)
                : ('MMB.checkIn.funnel.actions.navigateBack' | finLocalization)
            "
            (clickBtn)="navigateBack(step)"
          >
          </fcom-button>
        </div>
        <div class="flex-1 flex--basis0 flex--end flex flex--center" *ngIf="passenger$ | async as passenger">
          <div class="font-body-1 bold-type ps-small-r" data-hj-suppress>
            {{ passenger.firstName }} {{ passenger.lastName }}
          </div>
          <div>
            <fcom-icon
              [name]="passenger.accompanyingTravelerId ? SvgLibraryIcon.ADULT_INFANT : SvgLibraryIcon.SINGLE_PAX"
            ></fcom-icon>
          </div>
        </div>
      </div>
    </fin-sub-header>
  </ng-container>

  <ng-container ngProjectAs="main-content">
    <div #scrollContainer class="subview-content-sub-wrapper grey-25-bg grow">
      <main class="grid-max-width grid-col-12">
        <div class="col-f sm-col-3-10">
          <ng-container *finLet="step$ | async as step">
            @switch (step) {
              @case (FinnairApisRequirementKeyEnum.PASSPORT) {
                <fin-apis-passport
                  [order$]="order$"
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  [nationalities$]="nationalities$"
                  [countries$]="countries$"
                  [genders$]="genders$"
                  (completed)="nextStep(step)"
                ></fin-apis-passport>
              }

              @case (FinnairApisRequirementKeyEnum.COUNTRY_OF_RESIDENCE) {
                <fin-apis-country-of-residence
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  [countries$]="countries$"
                  (completed)="nextStep(step)"
                >
                </fin-apis-country-of-residence>
              }

              @case (FinnairApisRequirementKeyEnum.VISA) {
                <fin-apis-visa
                  [order$]="order$"
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  [nationalities$]="nationalities$"
                  [countries$]="countries$"
                  [genders$]="genders$"
                  (completed)="nextStep(step)"
                ></fin-apis-visa>
              }

              @case (FinnairApisRequirementKeyEnum.PERMANENT_RESIDENT_CARD) {
                <fin-apis-visa
                  [order$]="order$"
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  [nationalities$]="nationalities$"
                  [countries$]="countries$"
                  [genders$]="genders$"
                  (completed)="nextStep(step)"
                ></fin-apis-visa>
              }

              @case (FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS) {
                <fin-apis-destination
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  [addressType]="FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS"
                  [arrivalCountryCode$]="arrivalCountryCode$"
                  (completed)="nextStep(step)"
                ></fin-apis-destination>
              }

              @case (FinnairApisRequirementKeyEnum.HOME_ADDRESS) {
                <fin-apis-destination
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  [addressType]="FinnairApisRequirementKeyEnum.HOME_ADDRESS"
                  [arrivalCountryCode$]="arrivalCountryCode$"
                  (completed)="nextStep(step)"
                ></fin-apis-destination>
              }

              @case (FinnairApisRequirementKeyEnum.EMERGENCY_CONTACT) {
                <fin-apis-emergency-contact
                  [order$]="order$"
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  (completed)="nextStep(step)"
                ></fin-apis-emergency-contact>
              }

              @case (FinnairApisRequirementKeyEnum.PURPOSE_OF_VISIT) {
                <fin-apis-purpose-of-visit
                  [passenger$]="passenger$"
                  [boundId$]="boundId$"
                  (completed)="nextStep(step)"
                ></fin-apis-purpose-of-visit>
              }

              @default {
                <div class="ps-large">
                  <fcom-button [text]="'All done! Continue.'" (clickBtn)="nextStep(step)"></fcom-button>
                </div>
              }
            }
          </ng-container>
        </div>
      </main>
    </div>
  </ng-container>
</fin-subview>
